var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class Denon500BD {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        this.framework = framework;
        // other class properties and constructor
        this.configuredCodes = [];
        this.ignorePollDurationMs = 2000;
        this.afterStopDurationMs = 1000;
        this.lastUpdateTime = 0;
        this.playerMediaOperationCaps = [
            'back',
            'directionEnter',
            'directionUpDownLeftRight',
            'exit',
            'info',
            'mediaPlayerForward',
            'mediaPlayerNext',
            'mediaPlayerPause',
            'mediaPlayerPlay',
            'mediaPlayerPrevious',
            'mediaPlayerReverse',
            'mediaPlayerStop',
            'menu',
        ];
        this.mediaStateMap = {
            // DVSU: 'stopped', // setup
            // ED: 'stopped', // menu
            DVFF: 'forwarding',
            DVFR: 'reversing',
            DVFS: 'playing',
            DVHM: 'stopped',
            DVSF: 'playing',
            DVSP: 'playing',
            DVSR: 'playing',
            DVTR: 'playing',
            PL: 'playing',
            PP: 'paused',
        };
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: '@0?PW',
                unterminatedRegExp: /ack/i,
                next: /ack/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.mediaPlayerState = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const state = this.state.mediaPlayerState.values[key];
                if (state === undefined) {
                    this.log.error(`no mediaPlayerState for ${key}`);
                    return 'stopped';
                }
                return state;
            }),
            getKeys: () => this.configuredCodes.filter(code => this.configuredCodes.includes(code)),
        };
        this.mediaOperation = {
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                if (value.operation === 'mediaPlayerForward') {
                    const match = yield this.socket.send(`@0PCSLSFf`, /@0ST(DVFF)/i, tags);
                    this.lastUpdateTime = Date.now();
                    this.state.mediaPlayerState.update(key, this.mediaStateMap[match[1]]);
                }
                else if (value.operation === 'mediaPlayerNext') {
                    yield this.socket.send(`@02332`, /@0STPL/i, tags);
                    this.lastUpdateTime = Date.now();
                    this.state.mediaPlayerState.update(key, 'playing');
                }
                else if (value.operation === 'mediaPlayerPause') {
                    // pause or pausing a pause will cause the system to play
                    const match = yield this.socket.send(`@02348`, /@0ST(PP|PL)/i, tags);
                    this.lastUpdateTime = Date.now();
                    this.state.mediaPlayerState.update(key, this.mediaStateMap[match[1]]);
                }
                else if (value.operation === 'mediaPlayerPlay') {
                    const match = yield this.socket.send(`@02353`, /@0ST(PL)/i, tags);
                    this.lastUpdateTime = Date.now();
                    this.state.mediaPlayerState.update(key, this.mediaStateMap[match[1]]);
                }
                else if (value.operation === 'mediaPlayerPrevious') {
                    yield this.socket.send(`@02333`, /@0STPL/i, tags);
                    this.lastUpdateTime = Date.now();
                    this.state.mediaPlayerState.update(key, 'playing');
                }
                else if (value.operation === 'mediaPlayerReverse') {
                    const match = yield this.socket.send(`@0PCSLSRf`, /@0ST(DVFR)/i, tags);
                    this.lastUpdateTime = Date.now();
                    this.state.mediaPlayerState.update(key, this.mediaStateMap[match[1]]);
                }
                else if (value.operation === 'mediaPlayerStop') {
                    yield this.socket.send(`@02354`, /@0STPL/i, tags);
                    this.lastUpdateTime = Date.now();
                    this.state.mediaPlayerState.update(key, 'stopped');
                }
                else if (value.operation === 'directionLeft') {
                    yield this.socket.send(`@0PCCUSR1`, /^ack|^nack/i, tags);
                }
                else if (value.operation === 'directionRight') {
                    yield this.socket.send(`@0PCCUSR2`, /^ack|^nack/i, tags);
                }
                else if (value.operation === 'directionUp') {
                    yield this.socket.send(`@0PCCUSR3`, /^ack|^nack/i, tags);
                }
                else if (value.operation === 'directionDown') {
                    yield this.socket.send(`@0PCCUSR4`, /^ack|^nack/i, tags);
                }
                else if (value.operation === 'directionEnter') {
                    yield this.socket.send(`@0PCENTR`, /^ack|^nack/i, tags);
                }
                else if (value.operation === 'back' || value.operation === 'exit') {
                    // use device's "return"
                    yield this.socket.send(`@0PCRTN`, /^ack|^nack/i, tags);
                }
                else if (value.operation === 'info') {
                    yield this.socket.send(`@0DVDSIF`, /^ack|^nack/i, tags);
                }
                else if (value.operation === 'menu') {
                    // selecting menu stops playing
                    yield this.socket.send(`@0PCHM`, /^ack|^nack/i, tags);
                    this.lastUpdateTime = Date.now();
                    this.state.mediaPlayerState.update(key, 'stopped');
                }
                return value;
            }),
            asyncHandlers: {
                regExp: /^@0ST(PP|PL|DVFF|DVFR|DVHM)/i,
                callback: (match) => {
                    var _a;
                    // After a stop function, the system will still report @0STPL for play.
                    if (Date.now() < this.lastUpdateTime + this.afterStopDurationMs)
                        return;
                    this.state.mediaPlayerState.update((_a = this.currentInputCode) !== null && _a !== void 0 ? _a : '1', this.mediaStateMap[match[1]]);
                },
            },
        };
        this.mediaOperations = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const ops = {};
                for (const code of this.configuredCodes) {
                    ops[code] = [...this.playerMediaOperationCaps];
                }
                return ops;
            }),
        };
        // The system can be powered on over RS-232 after it has been powered off
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`@0?PW`, /^(ack|nack)$/i, tags);
                return match[1] === 'ack';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                // Sometimes we get a nack back. Retry a few times if we do.
                for (let n = 0; n < 5; n++) {
                    const match = yield this.socket.send(`@0PW0${power ? '0' : '1'}`, /^(ack|nack)$/i, tags, { retryAttempts: 2 } // Room power off can fail with a timeout, so retry
                    );
                    if (match[1] === 'ack') {
                        this.state.busy.update(true);
                        this.busyTimeout.set(() => this.state.busy.update(false), power ? 10000 : 12000);
                        // Suspend polling since the system can be unresponsive after a power change.
                        this.framework.suspendPolling(power ? 10000 : 12000);
                        return power;
                    }
                }
                return this.state.power.value;
            }),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () {
                // The device does not support powering on over port 9030 once it has been powered off.
                // It can be powered on over RS-232 control which uses port 4999.
                return this.socket.options.port === 4999;
            }),
            isStateless: false,
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    const match = yield this.socket.send(`@0?ST`, /ack\+@0ST(.+)|(ack\+)|(nack)/i, [
                        'poll',
                    ]);
                    if (Date.now() < this.lastUpdateTime + this.ignorePollDurationMs)
                        return;
                    if (match[1] && match[1] !== 'nack') {
                        this.state.mediaPlayerState.update((_a = this.currentInputCode) !== null && _a !== void 0 ? _a : '1', (_b = this.mediaStateMap[match[1]]) !== null && _b !== void 0 ? _b : 'stopped');
                    }
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.configuredCodes = Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {}).map(v => v.code);
            this.configuredCodes.forEach(code => this.state.mediaPlayerState.update(code, 'stopped'));
            if (this.configuredCodes.length > 0 &&
                (this.currentInputCode === undefined ||
                    !this.configuredCodes.includes(this.currentInputCode))) {
                this.currentInputCode = this.configuredCodes.sort()[0];
            }
            // Get the initial state.
            const match = yield this.socket.send(`@0?ST`, /ack\+@0ST(.+)|(ack\+)|(nack)/i, ['poll']);
            if (match[1] && match[1] !== 'nack') {
                this.state.mediaPlayerState.update((_b = this.currentInputCode) !== null && _b !== void 0 ? _b : '1', (_c = this.mediaStateMap[match[1]]) !== null && _c !== void 0 ? _c : 'stopped');
            }
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
Denon500BD.driverType = 'socketDriver';
Denon500BD.key = '-M_6DFMTlS8jno2tPzoT';
Denon500BD.baseSocketOptions = {
    commandExtractor: (buffer) => {
        // Responses to commands are either ack, nack, or @message with no line terminator or
        // ack+@0message for status responses
        for (let k = 0; k < buffer.length - 1; k++) {
            const buf = buffer.slice(k);
            if (buf.startsWith('nack')) {
                const command = buf.slice(0, 4);
                buffer = buf.slice(4);
                return { command, buffer };
            }
            else if (buf.startsWith('ack+@0')) {
                // ack+@0cmd
                let j = 6;
                while (buf[j] !== '@' && j < buf.length) {
                    j++;
                }
                if (j >= 9) {
                    // All ack+commmands are at least 10 characters
                    const command = buf.slice(0, j);
                    buffer = buf.slice(j);
                    return { command, buffer };
                }
            }
            else if (buf.startsWith('ack+')) {
                // response from polls when stopped
                const command = buf.slice(0, 4);
                buffer = buf.slice(4);
                return { command, buffer };
            }
            else if (buf.startsWith('@0')) {
                // Start of a new command/ack, look for next @ or end of buffer.
                let j = 2;
                while (buf[j] !== '@' && j < buf.length) {
                    j++;
                }
                if (j >= 5) {
                    // All commmands are at least 6 characters, 5 + @
                    const command = buf.slice(0, j);
                    buffer = buf.slice(j);
                    return { command, buffer };
                }
            }
            else if (buf.startsWith('ack')) {
                const command = buf.slice(0, 3);
                buffer = buf.slice(3);
                return { command, buffer };
            }
        }
        return undefined;
    },
    sendTerminator: '\r',
};
Denon500BD.socketOptions = [
    Object.assign(Object.assign({}, Denon500BD.baseSocketOptions), { port: 9030 }),
    Object.assign(Object.assign({}, Denon500BD.baseSocketOptions), { port: 4999 }),
];
